<template>
	<div
		class="absolute right-1 bottom-11 left-1 z-4 space-y-px bg-transparent transition-all duration-500"
		:class="{
			'bg-black *:opacity-0': tallying,
			'top-11.75': isJackpot && move,
			'top-1': !isJackpot || !move
		}"
	>
		<div
			class="flex items-stretch gap-px transition-opacity duration-300"
			v-if="participants.length === 2"
		>
			<div class="relative flex h-60 flex-1 pb-4">
				<BattleSpinAvatar
					v-if="participants[0].avatar && participants[0].name"
					:avatar="participants[0].avatar"
					:name="participants[0].name"
					:team="participants[0].teamIndex"
					:outlineAvatar="outlineAvatar"
					side="left"
					:shine="shineIndecies.includes(0)"
				/>
				<BattleSpinItemInfo
					v-if="itemInfos[0]"
					class="mt-auto w-full"
					:collectionName="itemInfos[0].collectionName"
					:modelName="itemInfos[0].modelName"
					:price="itemInfos[0].price"
					:color="itemInfos[0].color"
				/>
			</div>
			<div class="relative flex h-60 flex-1 pb-4">
				<BattleSpinAvatar
					v-if="participants[1].avatar && participants[1].name"
					:avatar="participants[1].avatar"
					:name="participants[1].name"
					:team="participants[1].teamIndex"
					:outlineAvatar="outlineAvatar"
					side="right"
					:shine="shineIndecies.includes(1)"
				/>
				<BattleSpinItemInfo
					v-if="itemInfos[1]"
					class="mt-auto w-full"
					:collectionName="itemInfos[1].collectionName"
					:modelName="itemInfos[1].modelName"
					:price="itemInfos[1].price"
					:color="itemInfos[1].color"
				/>
			</div>
		</div>

		<div
			class="flex items-stretch gap-px transition-opacity duration-300"
			v-if="participants.length === 3"
		>
			<div class="relative flex h-60 flex-1 pb-4">
				<BattleSpinAvatar
					v-if="participants[0].avatar && participants[0].name"
					:avatar="participants[0].avatar"
					:name="participants[0].name"
					:team="participants[0].teamIndex"
					:outlineAvatar="outlineAvatar"
					side="left"
					:shine="shineIndecies.includes(0)"
				/>
				<BattleSpinItemInfo
					v-if="itemInfos[0]"
					class="mt-auto w-full"
					:collectionName="itemInfos[0].collectionName"
					:modelName="itemInfos[0].modelName"
					:price="itemInfos[0].price"
					:color="itemInfos[0].color"
				/>
			</div>
			<div class="relative flex h-60 flex-1 pb-4">
				<BattleSpinAvatar
					v-if="participants[1].avatar && participants[1].name"
					:avatar="participants[1].avatar"
					:name="participants[1].name"
					:team="participants[1].teamIndex"
					:outlineAvatar="outlineAvatar"
					side="left"
					:shine="shineIndecies.includes(1)"
				/>
				<BattleSpinItemInfo
					v-if="itemInfos[1]"
					class="mt-auto w-full"
					:collectionName="itemInfos[1].collectionName"
					:modelName="itemInfos[1].modelName"
					:price="itemInfos[1].price"
					:color="itemInfos[1].color"
				/>
			</div>
			<div class="relative flex h-60 flex-1 pb-4">
				<BattleSpinAvatar
					v-if="participants[2].avatar && participants[2].name"
					:avatar="participants[2].avatar"
					:name="participants[2].name"
					:team="participants[2].teamIndex"
					:outlineAvatar="outlineAvatar"
					side="left"
					:shine="shineIndecies.includes(2)"
				/>
				<BattleSpinItemInfo
					v-if="itemInfos[2]"
					class="mt-auto w-full"
					:collectionName="itemInfos[2].collectionName"
					:modelName="itemInfos[2].modelName"
					:price="itemInfos[2].price"
					:color="itemInfos[2].color"
				/>
			</div>
		</div>
		<template v-if="participants.length === 4">
			<div class="flex items-stretch gap-px transition-opacity duration-300">
				<div class="relative flex h-60 flex-1 pb-4">
					<BattleSpinAvatar
						v-if="participants[0].avatar && participants[0].name"
						:avatar="participants[0].avatar"
						:name="participants[0].name"
						:team="participants[0].teamIndex"
						:outlineAvatar="outlineAvatar"
						side="left"
						:shine="shineIndecies.includes(0)"
					/>
					<BattleSpinItemInfo
						v-if="itemInfos[0]"
						class="mt-auto w-full"
						:collectionName="itemInfos[0].collectionName"
						:modelName="itemInfos[0].modelName"
						:price="itemInfos[0].price"
						:color="itemInfos[0].color"
					/>
				</div>
				<div class="relative flex h-60 flex-1 pb-4">
					<BattleSpinAvatar
						v-if="participants[1].avatar && participants[1].name"
						:avatar="participants[1].avatar"
						:name="participants[1].name"
						:team="participants[1].teamIndex"
						:outlineAvatar="outlineAvatar"
						side="right"
						:shine="shineIndecies.includes(1)"
					/>
					<BattleSpinItemInfo
						v-if="itemInfos[1]"
						class="mt-auto w-full"
						:collectionName="itemInfos[1].collectionName"
						:modelName="itemInfos[1].modelName"
						:price="itemInfos[1].price"
						:color="itemInfos[1].color"
					/>
				</div>
			</div>
			<div class="flex items-stretch gap-px transition-opacity duration-300">
				<div class="relative flex h-60 flex-1 pb-4">
					<BattleSpinAvatar
						v-if="participants[2].avatar && participants[2].name"
						:avatar="participants[2].avatar"
						:name="participants[2].name"
						:team="participants[2].teamIndex"
						:outlineAvatar="outlineAvatar"
						side="left"
						:shine="shineIndecies.includes(2)"
					/>
					<BattleSpinItemInfo
						v-if="itemInfos[2]"
						class="mt-auto w-full"
						:collectionName="itemInfos[2].collectionName"
						:modelName="itemInfos[2].modelName"
						:price="itemInfos[2].price"
						:color="itemInfos[2].color"
					/>
				</div>
				<div class="relative flex h-60 flex-1 pb-4">
					<BattleSpinAvatar
						v-if="participants[3].avatar && participants[3].name"
						:avatar="participants[3].avatar"
						:name="participants[3].name"
						:team="participants[3].teamIndex"
						:outlineAvatar="outlineAvatar"
						side="right"
						:shine="shineIndecies.includes(3)"
					/>
					<BattleSpinItemInfo
						v-if="itemInfos[3]"
						class="mt-auto w-full"
						:collectionName="itemInfos[3].collectionName"
						:modelName="itemInfos[3].modelName"
						:price="itemInfos[3].price"
						:color="itemInfos[3].color"
					/>
				</div>
			</div>
		</template>
	</div>
</template>
<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import BattleSpinAvatar from './BattleSpinAvatar.vue'
import { sleep } from '@/utils/sleep'
import BattleSpinItemInfo from './BattleSpinItemInfo.vue'

const props = defineProps<{
	participants: {
		name: string | null
		avatar: string | null
		isBot: boolean | null
		teamIndex: number
		slotIndex: number
	}[]
	tallying?: boolean
	isJackpot?: boolean
}>()

const shineIndecies = ref<number[]>([])

const shine = async (index: number) => {
	shineIndecies.value.push(index)
	await sleep(1500)
	const i = shineIndecies.value.indexOf(index)

	if (i === -1) {
		return
	}

	shineIndecies.value.splice(i, 1)
}

const itemInfos = ref<
	(
		| {
				modelName: string
				collectionName: string
				price: number
				color: 'orange' | 'pink' | 'red' | 'blue'
		  }
		| undefined
	)[]
>([])

const showItemInfo = async (
	index: number,
	item: {
		modelName: string
		collectionName: string
		price: number
		color: 'orange' | 'pink' | 'red' | 'blue'
	}
) => {
	itemInfos.value[index] = item
}

const hideItemInfo = (index: number) => {
	itemInfos.value[index] = undefined
}

const outlineAvatar = computed(() => {
	if (!props.isJackpot) {
		return false
	}

	const teamPlayers =
		props.participants.reduce((a, b) => Math.max(a, b.slotIndex), 0) + 1

	if (teamPlayers === 2) {
		return false
	}

	return true
})

const move = ref(false)

onMounted(async () => {
	if (!props.isJackpot) {
		return
	}

	await sleep(10)

	move.value = true
})

onBeforeUnmount(() => {
	move.value = false
})

defineExpose({
	shine,
	showItemInfo,
	hideItemInfo
})
</script>
